// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + {"676":"aeb08b7c67a4b3c9fd29","908":"cd280aeb47dab09e5166"}[chunkId] + ".js";
};